import React from 'react';
import { formatText, FormattedText } from 'core/i18n';

const REQUERIMENTS_LIST = [
    { id: 1, requeriment: 'iban', text: 'initial-creditCardProcessRequerimentIban' },
    { id: 2, requeriment: 'id', text: 'initial-creditCardProcessRequerimentId' },
    { id: 3, requeriment: 'mobile', text: 'initial-creditCardProcessRequerimentMobile' },
    { id: 4, requeriment: 'income', text: 'initial-creditCardProcessRequerimentIncome' },
];

export const CreditCardLightRequeriments = ({ conditionsText }) => {
    return (
        <div className="tc-light-header-requeriments">
            <div className="tc-light-header-requeriments-title">
                {formatText('initialInfoSection-descriptionLabelLight_basic')}
            </div>
            <div className="tc-light-header-requeriments-row">
                {REQUERIMENTS_LIST.map(({ id, requeriment, text }) => {
                    return (
                        <div className="tc-light-header-requeriment" key={id}>
                            <i className={`icons icons--icon-process-documents-${requeriment}`} />
                            <div className="tc-light-header-requeriment-label">
                                <FormattedText value={text} />
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="tc-light-header-requeriments-conditions-info">
                <FormattedText value={conditionsText} />
            </div>
        </div>
    );
};
